import type { VoidFunctionComponent } from 'react';
import ReactMarkdown from 'react-markdown';
import classnames from 'classnames';
import styles from './Markdown.module.less';

type Props = {
  /**
   * The raw markdown text.
   */
  text: string;
  /**
   * Additional class name for styling.
   */
  className?: string;
};

/**
 * A react-markdown wrapper with custom styling.
 */
const Markdown: VoidFunctionComponent<Props> = ({ text, className }) => {
  const allClassNames = classnames(styles.markdown, className ?? '');

  return (
    <ReactMarkdown className={allClassNames}>
      {text}
    </ReactMarkdown>
  );
};

export default Markdown;
